"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FireplaceOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="M16 2C8.268 2 2 8.2 2 15.85v9.188c0 .531.436.962.972.962h26.056c.536 0 .972-.43.972-.962V15.85C30 8.2 23.732 2 16 2ZM3.944 15.85C3.944 9.263 9.342 3.924 16 3.924c6.658 0 12.056 5.34 12.056 11.926v8.226h-7.103a6.81 6.81 0 0 0 1.797-2.33 6.74 6.74 0 0 0 .639-2.863c0-2.224-1.318-3.792-2.453-5.142l-.296-.354c-1.238-1.492-2.307-2.958-2.307-5.276a.953.953 0 0 0-.365-.751.977.977 0 0 0-.82-.187c-1.748.39-2.81 1.245-3.396 2.334-.553 1.025-.618 2.15-.648 2.936l-.008.264c-.006.18-.012.332-.02.465a7.86 7.86 0 0 1-.82-.479.963.963 0 0 0-1.193.098h-.002l-.001.002-.004.003-.009.01a6.234 6.234 0 0 0-.404.432 8.39 8.39 0 0 0-.833 1.184 8.805 8.805 0 0 0-1.199 4.46c0 .99.219 1.967.64 2.864a6.807 6.807 0 0 0 1.8 2.33H3.943V15.85Zm6.612 3.033a6.903 6.903 0 0 1 1.362-4.14c.281.16.579.291.887.392.461.14 1.107.201 1.624-.263.425-.382.518-.932.557-1.236.035-.279.045-.61.054-.913v-.004l.008-.205c.029-.784.098-1.505.42-2.103.187-.347.485-.698 1.019-.98.347 2.288 1.56 3.862 2.65 5.177l.215.26c1.228 1.473 2.092 2.513 2.092 4.015 0 2.619-2.131 5.001-5.44 5.001-3.312 0-5.448-2.384-5.448-5.001ZM6 28a1 1 0 1 0 0 2h20a1 1 0 1 0 0-2H6Z" clip-rule="evenodd" stroke="none"></path>';
var FireplaceOutlineSVG = function FireplaceOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FireplaceOutlineSVG = FireplaceOutlineSVG;
FireplaceOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FireplaceOutlineSVG);
exports.default = _default;